import React from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { logoutUser } from '../redux/userSlice';

import { LayoutDashboard, MessageSquare, ShoppingBag, Users, ShoppingCart, HeadphonesIcon, BarChart2, LogOut, PenSquare, Bell, QrCode } from 'lucide-react';

const EditorSidebar = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const menuItems = [

    { name: 'Dashboard', path: '/editor/dashboard', icon: <LayoutDashboard size={25} />, badge: null },
    { name: 'Mesajlar', path: '/editor/message', icon: <MessageSquare size={25} />, badge: 4 },
    { name: 'Ürünler', path: '/editor/products', icon: <ShoppingBag size={25} />, badge: null },
    { name: 'Müşteriler', path: '/editor/customers', icon: <Users size={25} />, badge: null },
    { name: 'Siparişler', path: '/editor/orders', icon: <ShoppingCart size={25} />, badge: 12 },
    { name: 'Destek', path: '/editor/support', icon: <HeadphonesIcon size={25} />,  badge: 3 },
    { name: 'Raporlar', path: '/editor/reports', icon: <BarChart2 size={25} />, badge: null },
    { name: 'QR Oluşturucu', path: '/editor/qrcode', icon: <QrCode size={25} /> },
  ];

  const logout = () => {

    localStorage.removeItem('token');
    dispatch(logoutUser());
    navigate('/editor/login');
  };

  const isActive = (path) => location.pathname === path;

  return (

    <div className="sticky top-10 z-10">

      <div className="hidden lg:flex flex-col min-w-[280px] bg-white dark:bg-slate-900 text-gray-900 dark:text-white border-r border-gray-200 dark:border-slate-800 shadow-lg dark:shadow-none transition-colors duration-300">

        <div className="py-6 px-6 border-b border-gray-200 dark:border-slate-800 bg-white dark:bg-slate-900">

          <div className="flex items-center gap-3">

            <div className="bg-gradient-to-br from-blue-400 via-blue-500 to-indigo-500 p-2 rounded-xl shadow-lg shadow-indigo-500/30">
              <PenSquare className="text-white" size={24} />
            </div>

            <div>

              <span className="text-xl font-black block tracking-tight -mb-2 text-gray-900 dark:text-white">SMART<span className="text-blue-500">HUB</span></span>
              <span className="text-blue-400 dark:text-blue-400 text-[10px] uppercase font-bold tracking-widest">Editör Paneli</span>

            </div>

          </div>

        </div>

        <div className="mx-4 mt-4 mb-2 bg-indigo-50 dark:bg-indigo-500/10 border border-indigo-100 dark:border-indigo-500/20 rounded-2xl px-4 py-3 flex items-center gap-3">

          <Bell size={16} className="text-blue-500 shrink-0" />
          <p className="text-xs text-blue-600 dark:text-blue-300 font-medium"><span className="font-black">19</span> bekleyen işlem var</p>

        </div>

        <nav className="flex-1 p-4 space-y-1 overflow-y-auto no-scrollbar">

          {menuItems.map((item) => ( <Link key={item.path} to={item.path} className={`flex items-center gap-4 p-4 rounded-2xl transition-all duration-300 font-medium ${isActive(item.path) ? 'bg-blue-500 text-white shadow-lg shadow-blue-500/40' : 'hover:bg-gray-100 dark:hover:bg-slate-800 text-gray-600 dark:text-slate-400 hover:text-gray-900 dark:hover:text-white'}`}>

            <span className={isActive(item.path) ? 'scale-110 transition-transform' : ''}>{item.icon}</span>
            <span className="flex-1">{item.name}</span>
            {item.badge && ( <span className={`text-[10px] font-black px-2 py-0.5 rounded-full min-w-[22px] text-center ${isActive(item.path) ? 'bg-white/20 text-white' : 'bg-blue-100 dark:bg-blue-500/20 text-blue-600 dark:text-blue-300'}`}>{item.badge}</span> )}

          </Link> ))}

        </nav>

        <div className="p-4 border-t border-gray-200 dark:border-slate-800">

          <div onClick={logout} className="flex items-center gap-4 text-gray-600 dark:text-slate-500 hover:text-red-500 dark:hover:text-red-400 p-4 cursor-pointer transition-all rounded-2xl hover:bg-red-50 dark:hover:bg-red-500/5 group">

            <LogOut size={25} className="group-hover:-translate-x-1 transition-transform" />
            <span className="font-bold uppercase text-xs tracking-wider">Sistemden Çık</span>

          </div>

        </div>

      </div>

      <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white dark:bg-slate-900 border-t border-gray-200 dark:border-slate-800 z-50 flex items-center h-20 shadow-[0_-10px_30px_rgba(0,0,0,0.1)] dark:shadow-[0_-10px_30px_rgba(0,0,0,0.5)] transition-colors duration-300">

        <nav className="flex-1 flex overflow-x-auto no-scrollbar scroll-smooth px-2 items-center h-full">

          {menuItems.map((item) => ( <Link key={item.path} to={item.path} className={`relative flex flex-col items-center justify-center min-w-[75px] h-full transition-all ${isActive(item.path) ? 'text-indigo-500' : 'text-gray-500 dark:text-slate-500 hover:text-gray-700 dark:hover:text-slate-300'}`}>

            <span className={`transition-transform ${isActive(item.path) ? 'scale-110 mb-1' : ''}`}>{item.icon}</span>
            <span className="text-[10px] font-bold mt-1 whitespace-nowrap uppercase tracking-tighter">{item.name}</span>
            {item.badge && ( <span className="absolute top-2 right-3 w-4 h-4 bg-indigo-500 text-white text-[9px] font-black rounded-full flex items-center justify-center">{item.badge > 9 ? '9+' : item.badge}</span> )}
            {isActive(item.path) && ( <div className="w-1 h-1 bg-indigo-500 rounded-full mt-1 animate-pulse" /> )}

          </Link> ))}

        </nav>

        <div onClick={logout} className="flex flex-col items-center justify-center w-20 h-full bg-gray-50 dark:bg-slate-950 border-l border-gray-200 dark:border-slate-800 text-red-500 active:bg-red-50 dark:active:bg-red-500/10 transition-colors cursor-pointer shrink-0">

          <LogOut size={24} />
          <span className="text-[10px] mt-1 font-black uppercase">Çıkış</span>

        </div>

      </div>

      <style dangerouslySetInnerHTML={{__html: `

        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}} />

    </div>
  );
};

export default EditorSidebar;